<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-sidebar-fold`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M42.686 29.693a1.19 1.19 0 011.183 1.069l.007.121v10.234a1.19 1.19 0 01-1.69 1.08l-.115-.061-8.488-5.117a1.188 1.188 0 01-.107-1.965l.107-.073 8.489-5.117c.185-.112.397-.17.614-.17zM27 34a1 1 0 011 1v2a1 1 0 01-1 1H5a1 1 0 01-1-1v-2a1 1 0 011-1h22zm12-14a1 1 0 011 1v2a1 1 0 01-1 1H5a1 1 0 01-1-1v-2a1 1 0 011-1h34zm0-14a1 1 0 011 1v2a1 1 0 01-1 1H5a1 1 0 01-1-1V7a1 1 0 011-1h34z"/></svg>
</template>
<script>

export default {
  name: 'IconSidebarFold',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
